export default "__VITE_ASSET__72lAnUJ0__"